<template>

	<div class="card recipe" v-on:click.stop="recipeClick" :data-link="recipe.lc_link" :data-id="recipe.id" v-bind:class="{suggested : planner_suggested}" v-bind:data-index="index">

		<div class="image-wrapper">

			<transition name="fade">
				<div class="spinner" v-show="thinking"><i class="fas fa-utensil-fork"></i></div>
			</transition>

			<img v-if="recipe.lc_recipe_post_card_image" class="card-img-top nopin" v-bind:src="recipe.lc_recipe_post_card_image" v-bind:alt="recipe.post_title">

		</div>

		<FavouriteWidget v-if="logged_in" v-bind:post.sync="recipe"></FavouriteWidget>

		<PlannerWidget v-if="logged_in && show_planner" :logged_in="logged_in" :mode="planner_mode" :show_suggest="planner_show_suggest" :post_id_prop="parseInt(recipe.ID)" :date="planner_date"></PlannerWidget>

		<div v-if="planner_suggested" class="suggested-label">Suggested</div>

		<div class="card-body">

			<div class="card-title" v-html="recipe.post_title"></div>

			<div class="info" v-if="show_info">

				<div v-if="recipe.lc_recipe_post_top_serves">Serves {{recipe.lc_recipe_post_top_serves}}</div>
				<div v-if="recipe.lc_recipe_post_top_cook_time">Cook {{recipe.lc_recipe_post_top_cook_time}}</div>
				<div v-if="recipe.lc_recipe_post_top_prep_time">Prep {{recipe.lc_recipe_post_top_prep_time}}</div>

			</div>

			<div class="timestamp" v-if="recipe.lc_timestamp && single_video">Timestamp: {{recipe.lc_timestamp}}</div>

			<div class="debug" v-if="debug">

				<table>
					<tbody>
						<tr>
							<td>Post id</td>
							<td>{{recipe.ID}}</td>
						</tr>
						<tr>
							<td>Pregnancy friendly</td>
							<td>{{recipe.lc_pregnancy_friendly.toString()}}</td>
						</tr>
						<tr v-if="planner_date">
							<td>Planner date</td>
							<td>{{JSON.stringify(planner_date)}}</td>
						</tr>
					</tbody>
				</table>

			</div>

		</div>

	</div>

</template>

<script>
	module.exports = {

		name: 'RecipeCard',

		props: {

			recipe: Object,

			pull_in_recipe: {

				type: Boolean,
				default: false,

			},
			show_info: {

				type: Boolean,
				default: true,

			},
			show_planner: {

				type: Boolean,
				default: true,

			},
			click: {

				type: Boolean,
				default: true,

			},
			planner_mode: {

				type: String,
				default: 'add',

			},
			planner_date: {

				type: Object,
				default: function() { return {} }
			},
			planner_show_suggest: {

				type: Boolean,
				default: false,

			},
			planner_suggested: {

				type: Boolean,
				default: false,

			},

			//used to determine position in the list
			index: {

				type: Number,
				default: 0,

			},

		},

		data() {

			return {

				thinking: false,
				navigating: false,
				logged_in: coreHelpers.getNested(pageData, 'logged_in'),
				single_video: coreHelpers.getNested(pageData, 'video'),
				logged_in: coreHelpers.getNested(pageData, 'logged_in'),
				debug: false,
			}

		},

		mounted() {

			//do things when the whole page including state is cached (especially mobile safari)
			/* window.addEventListener('onpageshow', () => {

                console.log('LC: onpageshow event triggered');

				if (event.persisted) {

					this.navigating = false;
					this.thinking = false;

				}

			}); */

			const url = new URL(window.location);
			const params = new URLSearchParams(url.search);
			if (params.has('debug')) {

				this.debug = true;

			}

		},

		computed: {

			fav() {

				return this.recipe.lc_is_fav;
			}

		},

		methods: {

			recipeClick() {

				console.log('LC: recipe click detected');

				this.navigating = true;;

				if (!this.click) {
					return false;
				}

				if (this.pull_in_recipe) {

					console.log('LC: pulling in recipe');

					this.getRecipe();

				} else {

					if (this.index > 0) {

						localStorage.setItem('recipe-index', this.index);

					}

					window.location = this.recipe.lc_link;

				}

			},

			getRecipe() {

				if (this.thinking) {
					return false;
				}

				this.thinking = true;

				window.vueRecipeList.recipe = false;

				coreHelpers.ajax('POST', 'lc_get_recipe', {

					'recipe_id': this.recipe.ID,

				}, this.getRecipeCallback, this.getRecipeFailureCallback);

			},

			getRecipeCallback(res) {

				this.thinking = false;

				if (res.success === true) {

					pageData.recipe = res.data.recipe;
					window.vueRecipeList.recipe = true;

				} else {

					coreVariables.triggerModal('Slight problem', 'Something has gone wrong, please try again later');
				}

			},

			getRecipeFailureCallback(res) {

				this.thinking = false;

				coreVariables.triggerModal('Slight problem', 'Something has gone wrong, please try again later');

			},

		}

	}
</script>